export default __webpack_public_path__ + "static/media/IMG-20241210-WA0032.d871c44d.jpg";